import React from "react";
import { StrongText } from "../common";

function HeadingText({ children = "" }) {
  return String(children)
    .split(/(<span>.*?<\/span>)/gi)
    .map((part, index) => {
      const spanMatch = part.match(/^<span>(.*?)<\/span>$/i);

      return spanMatch ? (
        <span key={`${spanMatch[1]}-${index}`}>{spanMatch[1]}</span>
      ) : (
        <React.Fragment key={`${part}-${index}`}>{part}</React.Fragment>
      );
    });
}

export default function ReadyToElevateSection({ data, onAction, className = "" }) {
  if (!data) return null;

  const paragraphs = Array.isArray(data.paragraphs)
    ? data.paragraphs
    : data.description
      ? [data.description]
      : [];

  return (
    <section className={`ready-to-elevate-section ${className}`.trim()}>
      
        <div className="container">
          <div className="ready-to-elevate-background" style={{ "--ready-to-elevate-image": `url("${data.backgroundImage}")` }} >
            <div className="row">
              <div className="col-lg-10 col-md-9">
                <div className="ready-to-elevate-content">
                  <h2 className="heading">
                    <HeadingText>{data.title}</HeadingText>
                  </h2>
                  {paragraphs.map((paragraph, index) => (
                    <p key={`${paragraph}-${index}`}>
                      <StrongText>{paragraph}</StrongText>
                    </p>
                  ))}
                  {data.button && onAction && (
                    <button
                      type="button"
                      className="default-btn white-font"
                      onClick={onAction}
                    >
                      {data.button}
                    </button>
                  )}
                </div>
              </div>
            </div>
        </div>
      </div>
    </section>
  );
}
